import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

function init() {
    $(document).on("dblclick", "#tblSiteAssignment tbody tr", goToPerson);
    $(document).on("click", "tr [personid]", deleteSiteAssignment);
}
function goToPerson() {
    forms.showSpinner();
    window.location.href = application.baseUrl + "/person/index/" + $(this).attr("personId");
}

function deleteSiteAssignment() {
    const $td = $(this);
    if ($td.find("a").hasClass("disabled")) {
        return;
    }

    $td.find("a").addClass("disabled");
    
    dataaccess.delete({ url: "/api/site/" + $("#hdnSiteId").val() + "/person/" + $(this).attr("personid") }).done(
        function() {
            $td.parent("tr").remove();
            if (!$("#tblSiteAssignment > tbody >tr").length) {
                $("#divNoAssignments").removeClass("hidden");
                $("#divTblWrapper").addClass("hidden");
            } else {
                $("#divNoAssignments").addClass("hidden");
                $("#divTblWrapper").removeClass("hidden");
            }
            services.notificationService.success("Successfully deleted site assignment.");
            $td.find("a").removeClass("disabled");
        });
}

export const siteAssignment = {
    init: init
};